import React, { useRef, useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import s from './TestResultAdmin.module.scss';
import { injectIntl } from 'react-intl';
import TestPurposeList from '../TestPurpose/TestPurposeList';
import TestCategoryList from '../TestCategory/TestCategoryList';

import OperationalSetupContentTemplate from '../OperationalSetup/OperationalSetupContentTemplate';
import { getQuerystring } from '../../utils/index';

const TestResultAdmin = ({ intl }) => {
  let posRef = useRef();
  let approvedRef = useRef();
  const userProfileWidgets = useSelector(state => state.userProfileWidgets);

  let list = getQuerystring('list');
  useLayoutEffect(() => {
    if (list === '1' && approvedRef.current) {
      window.scrollTo({
        top: approvedRef.current.offsetTop
      });
    } else if (list === '2' && posRef.current) {
      window.scrollTo({
        top: posRef.current.offsetTop
      });
    }
  }, [posRef, approvedRef, list]);

  return (
    <div className={s.mainComponent}>
      <OperationalSetupContentTemplate selectedPage="testResults" userProfileWidgets={userProfileWidgets}>
        <div className={s.contentWrapper}>
          <div className={s.mainComponentContent}>
            <TestCategoryList userProfileWidgets={userProfileWidgets} />
            <TestPurposeList userProfileWidgets={userProfileWidgets} />
            <div ref={approvedRef} />
          </div>
        </div>
      </OperationalSetupContentTemplate>
    </div>
  );
};

TestResultAdmin.defaultProps = {};

export default injectIntl(TestResultAdmin);
